module.exports = "<div class=\"spinner-border text-warning\"\r\n     role=\"status\">\r\n  <span class=\"sr-only\">Loading...</span>\r\n</div>\r\n"